import { render, staticRenderFns } from "./doQues.vue?vue&type=template&id=3a459af6&scoped=true"
import script from "./doQues.vue?vue&type=script&lang=js"
export * from "./doQues.vue?vue&type=script&lang=js"
import style0 from "./doQues.vue?vue&type=style&index=0&id=3a459af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a459af6",
  null
  
)

export default component.exports